import React, {useState} from 'react';
import { Col, Row, Segmented } from "antd";
import { packStockBySector, prepareInclusionExclusionScatter } from "./utils/smaChartUtils";
import NivoTreeChart from "../../charts/nivo/NivoTreeChart";
import NivoCircleChart from "../../charts/nivo/NivoCircleChart";
import SectorLegend from "./Sectors/SectorLegend";
import {normalizeWeights} from "../../lib/weightSchemes";

export const describeCoverageStats = (kept, removed) => {
  // Create a map to hold stats by sector
  const sectorStats = {};

  // Initialize stats for kept stocks
  kept.forEach(stock => {
    const { sector, symbol, wgt } = stock;
    if (!sectorStats[sector]) {
      sectorStats[sector] = { keptCount: 0, removedCount: 0, totalKeptWeight: 0, totalRemovedWeight: 0 };
    }

    // Update kept count and total weight
    sectorStats[sector].keptCount += 1;
    sectorStats[sector].totalKeptWeight += wgt * 100;  // Assuming wgt is a fraction of the total portfolio
  });

  // Initialize stats for removed stocks
  removed.forEach(stock => {
    const { sector, symbol, wgt } = stock;
    if (!sectorStats[sector]) {
      sectorStats[sector] = { keptCount: 0, removedCount: 0, totalKeptWeight: 0, totalRemovedWeight: 0 };
    }

    // Update removed count and total weight
    sectorStats[sector].removedCount += 1;
    sectorStats[sector].totalRemovedWeight += wgt * 100;  // Assuming wgt is a fraction of the total portfolio
  });

  // Summarize the stats for each sector
  const summary = Object.entries(sectorStats).map(([sector, stats]) => {
    const {
      keptCount,
      removedCount,
      totalKeptWeight,
      totalRemovedWeight,
    } = stats;

    return {
      sector,
      keptCount,
      removedCount,
      totalKeptWeight: totalKeptWeight.toFixed(2) + '%',
      totalRemovedWeight: totalRemovedWeight.toFixed(2) + '%',
    };
  });

  // Optionally calculate total portfolio weight kept/dropped
  const totalKeptWeight = kept.reduce((sum, stock) => sum + stock.wgt * 100, 0);
  const totalRemovedWeight = removed.reduce((sum, stock) => sum + stock.wgt * 100, 0);

  return {
    sectorSummary: summary,
    totalKeptWeight: totalKeptWeight.toFixed(2) + '%',
    totalRemovedWeight: totalRemovedWeight.toFixed(2) + '%',
  };
};




const TickerCoverage = ({ condensedTickers, fullTickers }) => {
    const [view, setView] = useState('circle')
    const includedTickers = condensedTickers && condensedTickers.map(d=>d.symbol);
    let includedData = includedTickers && fullTickers.filter(d=>includedTickers.includes(d.symbol));
    let excludedData = includedTickers && fullTickers.filter(d=>!includedTickers.includes(d.symbol));
    includedData = normalizeWeights(includedData);
    excludedData = normalizeWeights(excludedData);
    const packedData = includedData && excludedData && packStockBySector(includedData, excludedData);
    const sectorBubbleData = includedData && prepareInclusionExclusionScatter(includedData, excludedData);
    const sectorCounts = includedData && prepareInclusionExclusionScatter(includedData, excludedData, true);
    const stats = describeCoverageStats(includedData, excludedData);
    const segmentConfig = [
      {
        label: "Circle",
        value: 'circle'
      },
      {
        label: "Tree",
        value: 'tree'
      }
    ]
    console.log("Stats", stats)
    console.log("Packed Data", packedData)
    return (
        <>
          <Row justify={'center'} align={'middle'} gutter={64} wrap={false}>
            <Col flex={'0 0 300px'}>
              <SectorLegend data={packedData}/>
            </Col>
            <Col flex={'auto'}>
              <Segmented options={segmentConfig} value={view} onChange={setView} className={'mx-3'}/>
              {view === 'circle' && (
                  <div style={{height: 700, width: '100%'}} >
                    <NivoCircleChart data={packedData} width={800}/>
                  </div>
              )}
              {
                view === 'tree' && (
                    <div style={{height: 700, width: '100%'}}>
                  <NivoTreeChart data={packedData}/>
                </div>
                )
              }


            </Col>
          </Row>
          <Row justify={'center'}>
            <Col flex={'0 0 1100px'}>
            </Col>
          </Row>
        </>
    )

}


export default TickerCoverage